var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import RadioButton from './RadioButton/RadioButton';
import styles from './RadioGroup.scss';
import WixComponent from '../BaseComponents/WixComponent';
import classNames from 'classnames';

/**
 * component for easy radio group creation.
 *
 * similar to HTML `<input type="radio"/>` except you don't need to handle `name` or click handlers
 */

var RadioGroup = function (_WixComponent) {
  _inherits(RadioGroup, _WixComponent);

  function RadioGroup(props) {
    _classCallCheck(this, RadioGroup);

    var _this = _possibleConstructorReturn(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));

    _this.name = uniqueId('RadioGroup_');
    return _this;
  }

  _createClass(RadioGroup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          disabled = _props.disabled,
          disabledRadios = _props.disabledRadios,
          value = _props.value,
          vAlign = _props.vAlign,
          display = _props.display,
          type = _props.type,
          spacing = _props.spacing,
          lineHeight = _props.lineHeight;

      var style = { lineHeight: lineHeight, marginBottom: display === 'vertical' && spacing };

      return React.createElement(
        'div',
        { className: classNames(styles[display], _defineProperty({}, styles.buttonType, type === 'button')) },
        React.Children.map(this.props.children, function (radio) {
          return React.createElement(
            RadioGroup.Radio,
            {
              dataHook: radio.props.dataHook,
              value: radio.props.value,
              name: _this2.name,
              onChange: onChange,
              vAlign: vAlign,
              type: type,
              disabled: disabled || disabledRadios.indexOf(radio.props.value) !== -1,
              checked: radio.props.value === value,
              style: style,
              icon: radio.props.icon
            },
            radio.props.children
          );
        })
      );
    }
  }]);

  return RadioGroup;
}(WixComponent);

RadioGroup.propTypes = {
  /** Callback function when user selects a different value */
  onChange: PropTypes.func,

  /** Selected radio button value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** the values of the disabled radio buttons */
  disabledRadios: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),

  /** Positioning of the radio bottom compared to the label */
  vAlign: PropTypes.oneOf(['center', 'top']),

  /** Make the entire control disabled */
  disabled: PropTypes.string,

  /** Decided which type of child controls to render */
  type: PropTypes.string,

  /** Display direction of the radios */
  display: PropTypes.oneOf(['vertical', 'horizontal']),
  children: PropTypes.arrayOf(function (propValue, key) {
    if (propValue[key].type.name !== 'RadioButton') {
      return new Error('RadioGroup: Invalid Prop children was given. Validation failed on child number ' + key);
    }
  }),

  /** Vertical spacing between radio buttons */
  spacing: PropTypes.string
};

RadioGroup.defaultProps = {
  disabledRadios: [],
  onChange: function onChange() {},
  value: '',
  vAlign: 'center',
  display: 'vertical',
  spacing: '12px',
  lineHeight: '24px'
};

RadioGroup.Radio = RadioButton;

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
//# sourceMappingURL=RadioGroup.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/RadioGroup/RadioGroup.js